<template>
    <!-- 答题卡 -->
    <div class="container practice">
        <!-- 头部信息部分 -->
        <el-card class="practice-header" shadow="never">
            <div slot="header" class="clearfix">
                <span style="font-size:28px;color:#333" v-text="examInfo.examName"></span>
            </div>
            <el-row>
                <el-col :span="8" class="info">
                    <img src="https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=4090061760,3566002114&fm=27&gp=0.jpg"/>
                    <span style="float:right;font-size:28px;">
                        <p v-text="examInfo.userName"></p>
                    </span>
                </el-col>
                <el-col :span="16" style="padding:20px">
                    <p style="margin-bottom:15px;">本试卷共{{examInfo.content.length}}题，总分{{examInfo.totalPoint}}分。</p>
                    <div style="width:600px;padding:0 10px">
                        <el-table style="width: 100%" size="mini" :border="true"
                                :header-cell-style="{
                                    textAlign:'center',
                                    backgroundColor:'#f5f5f6'
                                }"
                                :cell-style="{ textAlign: 'center' }"
                                :data="questionTypeNum">
                            <el-table-column prop="name" label="类别" width="80"></el-table-column>
                            <el-table-column v-for="item in showQuestionTypeList" :key="item.id" :label="item.name">
                                <template slot-scope="scope">
                                    <span>{{scope.row[item.id]}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div style="margin-top:20px">
                        考试时长：<span style="font-weight:700" v-text="examInfo.duration / 60"></span>分钟
                        <i style="margin-left:30px;font-style:normal">
                            考试时间段 <span v-text="examInfo.stTime"></span> - <span v-text="examInfo.etTime"></span>
                        </i>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <!-- 答题卡 -->
        <el-card shadow="never" class="practice-card">
            <el-row :gutter="20">
                <el-col :span="18">
                    <div class="practice-left">
                        <el-tabs type="card" shadow="never" :class="{
                                questionTabs: true,
                                isFixed: tabFixed
                            }" v-model="practiceType">
                            <el-tab-pane v-for="type in showQuestionTypeList" :key="String(type.id)"
                                        :label="`${type.name}(${questionAllList[String(type.id)].length})`" 
                                        :name="String(type.id)">
                            </el-tab-pane>
                            <keep-alive>
                                <exam-answer-page :questionType="practiceType" :questions="questionAllList[practiceType]"
                                        @already-change="handleAlreadyChange"
                                        @marked-change="handleMarkedChange">
                                </exam-answer-page>
                            </keep-alive>
                        </el-tabs>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div :class="{
                            'practice-right': true,
                            isFixed: tabFixed
                        }">
                        <div class="practice-right-header">
                            <div class="test-endTime">
                                <span>考试剩余时间</span>&nbsp;
                                <!-- 倒计时部分 -->
                                <countdownTime :duration="examInfo.rateTime"
                                            @time-end="handleTimeEnd"
                                            @time-end-warning="timeEndWarning">
                                </countdownTime>
                            </div>
                            <el-button type="primary" class="submit-btn" size="small" @click="handelCommitExam">提交试卷</el-button>
                        </div>
                        <div class="practice-right-footer">
                            <ul class="practice-status">
                                <li>
                                    <span style="backgroundColor:#eee"></span>&nbsp;
                                    <i>未答</i>
                                </li>
                                <li>
                                    <span style="backgroundColor:#14b14e"></span>&nbsp;
                                    <i>已答</i>
                                </li>
                                <li>
                                    <span style="backgroundColor:#f39a4b"></span>&nbsp;
                                    <i>标记</i>
                                </li>
                            </ul>
                            <ul class="practice-options">
                                <li v-for="(question, j) in examInfo.content" :key="j"
                                    :class="{
                                        isAlready: alreadyList.indexOf(question.questionId) > -1,
                                        isMarked: markedList.indexOf(question.questionId) > -1
                                    }">
                                    <a :href="`#${question.questionId}`" v-text="j + 1" @click="practiceType = String(question.questionTypeId)"></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <div :class="{
                'back_top': true,
                isFixed: tabFixed
            }" @click="backTop">
            <span>
                <i class="el-icon-top"></i>
            </span>
        </div>
    </div>
</template>

<script>
import { startEtexam, initques, commitExam, getEtexamDetail } from '@/api/exam/etexam';
import { getEtquestiontypeList } from '@/api/exam/etquestiontype'
import { formatQuestions, disorder } from '@/utils/exam';
import countdownTime from "./components/countdown";
import examAnswerPage from "@/views/exam/etexam/answer";
export default {
    data () {
        return {
            tabFixed: false,
            examInfo: {
                content: []
            }, // 考试信息
            practiceType: '1',
            questionTypeList: [],
            questionRecords: [],
            questionAllList: {
                '6': []
            },
            alreadys: {}, // 已答题
            markedList: [],
        };
    },
    computed: {
        alreadyList: function () {
            let arr = []
            Object.keys(this.alreadys).forEach(key => {
                this.alreadys[key].map(id => {
                    arr.push(id)
                })
            });
            return arr
        },
        showQuestionTypeList: function () {
            let arr = []
            this.questionTypeList.map(type => {
                if (this.questionAllList[type.id].length > 0) {
                    arr.push(type)
                }
            })
            return arr
        },
        questionTypeNum: function () {
            let arr = [
                { name: '题数' },
                { name: '分/题' },
                { name: '总分' },
            ];
            Object.keys(this.questionAllList).forEach(key => {
                let sum = 0;
                let length = this.questionAllList[key].length;
                this.questionAllList[key].map(item => {
                    sum += item.questionPoint;
                })
                arr[0][key] = `${length}题`;
                arr[1][key] = `${(sum / length).toFixed(2)}分/题`;
                arr[2][key] = `${(sum).toFixed(2)}分`;
            });
            return arr;
        }
    },
    components: {
        countdownTime,
        examAnswerPage
    },
    methods: {
        init () {
            this.getQuestionTypeList()
            this.initques()
            this.getExamInfo()
        },
        initques () {
            let { recordId } = this.$route.params
            initques(recordId).then(res => {
                this.questionRecords = res
                this.startExam()
            })
        },
        startExam () {
            let { id } = this.$route.params
            startEtexam(id).then(res => {
                let { content } = res
                let qList = { ...this.questionAllList }
                content = disorder(formatQuestions(content))
                content.map((item, questionIndex) => {
                    let answerItem = this.questionRecords.filter(record => {
                        return record.questionId === item.questionId
                    });
                    let answer = answerItem[0].answer
                    if (item.questionTypeId === 2) {
                        if (answer === '') {
                            answer = []
                        } else {
                            answer = answer.split('')
                        }
                    }
                    if (item.questionTypeId === 4) {
                        if (answer === '') {
                            answer = []
                            for (let i = 0; i < item.answer.length; i++) {
                                answer.push('')
                            }
                        } else {
                            answer = answer.split(',')
                        }
                    }
                    qList[item.questionTypeId].push({
                        ...item,
                        ...answerItem[0],
                        answer,
                        questionIndex
                    })
                })
                this.examInfo = {
                    ...this.examInfo,
                    ...res,
                    content
                }
                this.questionAllList = qList
            })
        },
        // 监听滚动条向下滚动
        handleScroll () {
            let scrollY =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            this.tabFixed = scrollY > 500;
        },
        //  回到顶部
        backTop () {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        },
        handleClick () {
            this.backTop()
        },
        // 获取题目类型列表
        getQuestionTypeList () {
            getEtquestiontypeList().then(res => {
                let oQuestions = {}
                res.map(type => {
                    oQuestions[String(type.id)] = []
                })
                this.practiceType = String(res[0].id)
                this.questionAllList = oQuestions
                this.questionTypeList = [ ...res ]
            })
        },
        handleAlreadyChange (already) {
            this.$set(this.alreadys, this.practiceType, already)
        },
        handleMarkedChange (marked) {
            this.markedList = marked
        },
        handleTimeEnd () {
            this.commitExam()
        },
        timeEndWarning (num) {
            this.$message.warning(`还剩${num / 60}分钟考试结束`);
        },
        // 点击"提交试卷"按钮
        handelCommitExam () {
            let alreadyArr = []
            let noAlreadyQue = 0
            Object.keys(this.alreadys).forEach(key => {
                alreadyArr = [
                    ...alreadyArr,
                    ...this.alreadys[key]
                ]
            });
            noAlreadyQue = this.questionRecords.length - alreadyArr.length
            this.$confirm(`此操作将提交试卷( ${noAlreadyQue} 题未做), 后期不可更改, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.commitExam()
            }).catch(() => {});
        },
        commitExam () {
            let { recordId } = this.$route.params
            commitExam(recordId).then(() => {
                // 查看考试历史(查看考试)         
                this.$router.push({
                    name: 'testView',
                    params: { recordId }
                });
            })
        },
		// 获取考试详情
		getExamInfo () {
            let { id } = this.$route.params
			getEtexamDetail(id).then(res => {
				this.examInfo = {
                    ...this.examInfo,
					antiCheatingArr: (() => {
						let arr = res.antiCheating.split(',')
						arr.map((item, i) => {
							if (item !== '1' && item !== '2') {
								let arr2 = item.split(':')
                                arr[i] = arr2
							}
						})
						return arr
					})()
				}
			})
		},
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    created () {
        this.init()
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
};
</script>

<style lang="less">
.practice {
    .el-tabs__header {
        z-index: 999;
        width: 805px;
        border: none;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__item {
        border: none;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
        border: none;
        width: 100%;
    }
    .el-tabs__nav-wrap {
        margin-bottom: 0;
    }
    .practice-card {
        .title-topic {
            padding: 40px;
            border: 1px solid #dcdcdc;
            &:hover {
                background-color: #f3f9f7;
            }
            .topic-tag {
                font-size: 12px;
                color: #777;
                span {
                    cursor: pointer;
                    float: right;
                    &.active {
                        color: #14b14e;
                    }
                }
            }
            .topic-list {
                margin-top: 20px;
                padding: 0 15px;
                .topic-list-child{
                    margin-bottom: 20px;
                }
            }
        }
        .practice-right {
            margin-top: 40px;
            .practice-right-header {
                border: 1px solid #dcdcdc;
                text-align: center;
                padding: 15px;
            }
        }
    }
}
.questionTabs {
    .el-tabs__header {
        position: static;
        margin-top: 0;
    }
    .el-tabs__item{
        font-size: 16px;
        padding: 0 20px;
    }
    &.isFixed {
        .el-tabs__header {
            position: fixed;
            top: 0;
            z-index: 999;
            background-color: #f5f5f5;
        }
    }
}
</style>

<style lang="less" scoped>
.practice {
    user-select: none;
    font-size: 14px;
    color: #666;
    .practice-header {
        margin: 30px 0;
        .info {
            padding: 50px 30px;
            img {
                float: left;
                border-radius: 50%;
                width: 100px;
                height: 100px;
                vertical-align: middle;
            }
        }
    }
    .test-endTime {
        color: #14b14e;
    }
    .submit-btn {
        width: 100%;
    }
    .practice-right {
        position: static;
        margin-top: 40px;
        &.isFixed {
            width: 255px;
            position: fixed;
            top: 0;
        }
    }
    .practice-right-footer {
        border: 1px solid #dcdcdc;
        margin-top: 20px;
        min-height: 500px;
        .practice-status {
            border-bottom: 1px solid #dcdcdc;
            padding: 15px;
            overflow: hidden;
            li {
                float: left;
                line-height: 15px;
                margin-right: 20px;
                span {
                    float: left;
                    width: 16px;
                    height: 16px;
                    margin-right: 5px;
                    cursor: pointer;
                }
                i {
                    font-style: normal;
                    float: left;
                }
            }
        }
        .practice-options {
            padding: 15px;
            > li {
                width: 24px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                display: inline-block;
                vertical-align: middle;
                margin: 2px;
                color: #777;
                background-color: #eee;
                > a {
                    color: inherit;
                    width: 100%;
                    height: 100%;
                    display: inline-block;
                }
                &.isAlready {
                    color: white;
                    background-color: #14b14e;
                }
                &.isMarked {
                    color: white;
                    background-color: #f39a4b;
                }
                &.isAlready.isMarked {
                    background: linear-gradient(135deg, #14b14e, #14b14e 50%, #f39a4b 50%, #f39a4b 100%);
                }
            }
        }
    }
    .back_top {
        display: none;
        position: fixed;
        width: 50px;
        height: 50px;
        bottom: 20px;
        right: 80px;
        text-align: center;
        font-size: 40px;
        background-color: #a3a5a9;
        color: #fff;
        cursor: pointer;
        opacity: 0.3;
        &:hover {
            opacity: 0.6;
        }
        &.isFixed {
            display: block;
        }
    }
}
</style>
